import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const deleteDocsCounterpartyOwner = async (custId) => {
  return await request.delete(
    `/Docs/counterparty_owner?id=${custId}`,
    null,
    'При изменении удалении адресата произошла ошибка документа произошла ошибка',
    'Error'
  );
};

const useDeleteDocsCounterpartyOwner = () => {
  const mutation = useMutation(deleteDocsCounterpartyOwner, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsCounterpartyOwnerDelete: mutation.isLoading,
    deleteDocsCounterpartyOwner: mutation.mutateAsync,
  };
};

export default useDeleteDocsCounterpartyOwner;
